<template>
  <div class="vars_insert">
    <div class="value" @click.stop="set_show(true)">
      <icon-plus class="icon" />{{ $tr('common.variables.insert_variable') }}
    </div>
    <lpopup v-if="show" class="droplist" :width="'171px'" @hide="set_show(false)">
      <div v-for="item in list" :key="item.id" class="item" @click="insert(item.id)">
        {{ item.name }}
      </div>
    </lpopup>
  </div>
</template>

<script>
  export default {
    name: 'VarsInsert',
    props: ['list'],
    data() {
      return {
        show: false
      };
    },

    methods: {
      set_show(v) {
        this.show = v;
      },

      insert(id) {
        this.$emit('insert', id);
        this.set_show(false);
      }
    }
  };
</script>

<style lang="scss" scoped>
@import '@/styles/variables';

.vars_insert {
  position: relative;

  .value {
    display: flex;
    align-items: center;
    font-size: 15px;
    height: 24px;
    line-height: 24px;
    cursor: pointer;

    .icon {
      margin-right: 4px;
      width: 9px;
      color: #233346;
    }
  }
  &:hover .value {
    color: $green-hover;
  }
  &:hover .icon {
    color: $green-hover;
  }
  .droplist {
    position: absolute;
    top: 30px;
    right: 0;
    z-index: 2;
    padding: 10px;

    .item {
      text-overflow: ellipsis;
      overflow-x: hidden;
      max-width: 100%;
      margin-bottom: 10px;
      height: 26px;
      line-height: 26px;
      white-space: nowrap;
      cursor: pointer;
      // // font-family: Roboto;
      font-style: normal;
      font-weight: 500;
      font-size: 15px;
      color: #233346;

      &:hover {
        color: $green-hover;
      }

      &:last-child {
        margin-bottom: 0;
      }
    }
  }
}
</style>
